import '../../App.css';
import svg16 from '../../img/svg/icn_16.svg';
import svg19 from '../../img/svg/icn_19.svg';
import svg17 from '../../img/svg/icn_17.svg';
import svg18 from '../../img/svg/icn_18.svg';
import svg20 from '../../img/svg/icn_20.svg';
import svg7 from '../../img/svg/icn_7.svg';
import svg6 from '../../img/svg/icn_6.svg';
import svg10 from '../../img/svg/icn_10.svg';
import svg5 from '../../img/svg/icn_5.svg';
import svg8 from '../../img/svg/icn_8.svg';
import svg9 from '../../img/svg/icn_9.svg';
import bg4 from '../../img/bg4.jpg';
import { ReactComponent as Logo } from '../../img/svg/icn_17.svg';
import { useState, useEffect } from 'react';

const cargarCarreras = (modalidad) => {
 const CarreraArray = [];
 modalidad.forEach((element) => {
  CarreraArray.push(element.carreras);
 });

 return CarreraArray;
};

const icons = [
 { icon: svg16, id: 8 },
 { icon: svg19, id: 10 },
 { icon: svg17, id: 23 },
 { icon: svg18, id: 33 },
 { icon: svg20, id: 35 },
 { icon: svg7, id: 37 },
 { icon: svg6, id: 40 },
 { icon: svg10, id: 43 },
 { icon: svg5, id: 96 },
 { icon: svg8, id: 60 },
 { icon: svg9, id: 79 },
];

function Step3({ setPage, page, carrera, setCarrera, validation, carreras, loading, loader }) {
 const [styleActiveAll, setActiveAll] = useState('active');
 const [styleActiveOnline, setActiveOnline] = useState('');
 const [styleActive, setActive] = useState('');
 const [array_carreras, setArray] = useState([]);
 const [filtering, setFiltering] = useState('all');

 useEffect(() => {
  setArray(cargarCarreras(carreras));
 }, []);

 const setStyles = (type) => {
  switch (type) {
   case '':
    setActive('active');
    setActiveAll('');
    setActiveOnline('');

    break;
   case 'all':
    setActive('');
    setActiveAll('active');
    setActiveOnline('');

    break;
   case 'online':
    setActive('');
    setActiveAll('');
    setActiveOnline('active');

    break;

   default:
    break;
  }
 };

 const getIcon = (id) => {
  return svg9;
 };

 const presencial = 'Presencial';
 const online = 'Online';

 return (
  <section class="step style--2">
   <div class="section--bg img--bg ">
    <img
     className="back3"
     alt=""
    />
   </div>
   <div class="in">
    <header class="marquee">
     <div class="in">
      <div class="maxwidth">
       <div class="logo gone"></div>
       <div class="ttl">
        <h2>Elige tu carrera</h2>
       </div>
       <div class="air gone"></div>
      </div>
     </div>
    </header>
    <main class="no--flex">
     <div class="maxwidth2">
      <div class="ttl text--center big steps-title titular bluecolor">
       Cuéntanos <b className="bold_letter"> ¿Qué quieres estudiar?</b>
      </div>
     </div>
     <div class="maxwidth padded--left padded--right">
      <nav class="filter">
       <ul>
        <li class={styleActive === '' ? 'active' : ''}>
         <div class="button submit">
          <button
           id="Todos"
           name="Todos"
           onClick={() => {
            setArray(cargarCarreras(carreras));
            setStyles('all'); //5 presencial 6 semi
           }}>
           Todos
          </button>
         </div>
        </li>

        {carreras.map((Element) => {
         return (
          <>
           <li class={styleActive === Element.nombre_modalidad ? 'active' : ''}>
            <div class="button submit">
             <button
              id={presencial}
              name={presencial}
              onClick={() => {
               setArray(cargarCarreras([Element]));
               setActive(Element.nombre_modalidad); //3 presencial 4 semi
              }}>
              {Element.nombre_modalidad}
             </button>
            </div>
           </li>
          </>
         );
        })}
       </ul>
      </nav>
      <div class="filterable required empty">
       {loader ? (
        <>
         <h1 className="loader-2">Cargando..</h1>
        </>
       ) : (
        <>
         <ul>
          {array_carreras.map((element) => {
           return (
            <>
             {element.map((c) => {
              return (
               <>
                <li
                 class="submit"
                 onClick={() => {
                  //setCarrera(c.id)
                  setCarrera(c);
                  setPage((currentPage) => currentPage + 1);
                 }}>
                 <button
                  className="red_button"
                  id={c.id_carrera}
                  name={c.id_carrera}>
                  <span className={carrera.id_carrera === c.id_carrera ? 'icn icn_ selected_icon' : 'icn icn_'}>
                   <span className={carrera.id_carrera === c.id_carrera ? 'selected' : ''}>
                    {c.carrera.url_icono_carrera === null ? (
                     <>
                      <Logo
                       alt=""
                       fill={carrera.id_carrera === c.id_carrera ? '#fff' : '#3aa8f9'}
                      />
                     </>
                    ) : (
                     <>
                      <img
                       alt=""
                       src={c.carrera.url_icono_carrera}
                       className={carrera.id_carrera === c.id_carrera ? 'sgv_icon_selected' : 'svg_icon'}
                      />
                     </>
                    )}
                   </span>
                  </span>
                  <span className={carrera.id_carrera === c.id_carrera ? 'name selected_name' : 'name'}>{c.carrera.nombre_carrera}</span>
                 </button>
                </li>
               </>
              );
             })}
            </>
           );
          })}
         </ul>
        </>
       )}
      </div>
     </div>
    </main>
   </div>
  </section>
 );
}

export default Step3;
